import { APIResult } from "models/api-results";
import { ApiEndPoints } from "./api-end-points";
import axiosInstance from "./axios/axios-instance";

export class WebAPIClient {

  static getData = async <T>(method: string, filter?: any, headerParam?: any): Promise<APIResult<T>> => {
    let _url = ApiEndPoints.base_url + method;

    /*****populate Url Param */
    const paramKeys: any = [];
    if (filter) {
      Object.keys(filter).map(key => {
        paramKeys.push(key + '=' + filter[key]);
        return paramKeys;
      });

      const _queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      _url += '?' + _queryString
    }
    var config: any = { headers: {} };
    if (headerParam) {
      Object.keys(headerParam).map(key => {
        config.headers[key] = headerParam[key];
      });
    }


    const res = await axiosInstance.get(_url, config).catch((error: any) => {
      return WebAPIClient.getCommonAPIError(error);
    })

    return res.data as APIResult<T>;
  }

  static postData = async <T>(method: string, data: any, headerParam?: any): Promise<APIResult<T>> => {
    let _url = ApiEndPoints.base_url + method;

    /*****populate Url Param */
    /*
    , filter?: any
    const paramKeys: any = [];
    if (filter) {
      Object.keys(filter).map(key => {
        paramKeys.push(key + '=' + filter[key]);
        return paramKeys;
      });

      const _queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      _url += '?' + _queryString
    }
 */
    var config: any = { headers: {} };
    if (headerParam) {
      Object.keys(headerParam).map(key => {
        config.headers[key] = headerParam[key];
      });
    }

    const res = await axiosInstance.post(_url, data, config).catch((error: any) => {
      return WebAPIClient.getCommonAPIError(error);
    })

    return res.data as APIResult<T>;
  }


  static patchData = async <T>(method: string, data: any, headerParam?: any): Promise<APIResult<T>> => {
    let _url = ApiEndPoints.base_url + method;

    var config: any = { headers: {} };
    if (headerParam) {
      Object.keys(headerParam).map(key => {
        config.headers[key] = headerParam[key];
      });
    }

    const res = await axiosInstance.patch(_url, data, config).catch((error: any) => {
      return WebAPIClient.getCommonAPIError(error);
    })
    return res.data as APIResult<T>;
  }


  static putData = async <T>(method: string, data: any, headerParam?: any): Promise<APIResult<T>> => {
    let _url = ApiEndPoints.base_url + method;

    var config: any = { headers: {} };
    if (headerParam) {
      Object.keys(headerParam).map(key => {
        config.headers[key] = headerParam[key];
      });
    }

    const res = await axiosInstance.put(_url, data, config).catch((error: any) => {
      return WebAPIClient.getCommonAPIError(error);
    })
    return res.data as APIResult<T>;
  }


  static getBlobData = async <T>(method: string, filter?: any, headerParam?: any): Promise<any> => {
    let _url = ApiEndPoints.base_url + method;

    /*****populate Url Param */
    const paramKeys: any = [];
    if (filter) {
      Object.keys(filter).map(key => {
        paramKeys.push(key + '=' + filter[key]);
        return paramKeys;
      });

      const _queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      _url += '?' + _queryString
    }
    var config: any = {
      headers: {}, responseType: 'blob', // Ensures the response is a blob
    };
    if (headerParam) {
      Object.keys(headerParam).map(key => {
        config.headers[key] = headerParam[key];
      });
    }


    const res = await axiosInstance.get(_url, config).catch((error: any) => {
      return WebAPIClient.getCommonAPIError(error);
    })
    if (res) {
      // Create a Blob URL for the PDF
      // const blob = res.data;
      //const url = URL.createObjectURL(blob);

      // Open the PDF in a new tab
      //  window.open(url, '_blank');
    } else {
      console.error('Failed to fetch the invoice.');
    }
    return res.data;
  }

  /*   patch_data = (url: any, data: any) => {
      return axiosInstance.patch(url, data);
    };
  
    put_data = (url: any, data: any) => {
      return axiosInstance.put(url, data);
    };
  
    delete_data = (url: any, config: any) => {
      return axiosInstance.delete(url, { ...config });
    };
   */

  static getCommonAPIError = <T>(error: any): { data: APIResult<T> } => {
    const _result = {
      status: {
        isError: true,
        errorMessage: 'Error occured',
        errorCode: "500",
      },
    } as APIResult<T>;
    if (error.response?.status) {
      _result.status!.errorCode = error.response?.data?.status?.errorCode ?? (error.response?.status ?? "");
      _result.status!.errorMessage = error.response?.data?.status?.errorMessage ?? (error.response?.statusText ?? "");
    }
    return { data: _result };
  }


}

